import { Instagram, Phone, Mail, MessageCircle } from "lucide-react";
import { SITE } from "../../data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="pt-20 pb-12"
      style={{ background: "var(--dl-ink)", color: "var(--dl-bg)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img
              src={SITE.logo}
              alt="Cheshire Holidays"
              className="w-28 h-28 object-cover mb-6"
              style={{ borderRadius: 2 }}
            />
            <p className="font-serif text-3xl" style={{ fontWeight: 400 }}>
              Cheshire Holidays
            </p>
            <p className="mt-4 max-w-md" style={{ color: "rgba(250,249,246,0.7)" }}>
              Cheshire countryside holiday cottages, shepherd&apos;s huts and lakeside
              lodges. Hand-built, peacefully placed.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href={SITE.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="w-11 h-11 border flex items-center justify-center transition-colors hover:bg-[color:var(--dl-bg)] hover:text-[color:var(--dl-ink)]"
                style={{ borderColor: "rgba(250,249,246,0.4)" }}
              >
                <Instagram size={18} />
              </a>
              <a
                href={SITE.whatsappHref}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
                className="w-11 h-11 border flex items-center justify-center transition-colors hover:bg-[color:var(--dl-bg)] hover:text-[color:var(--dl-ink)]"
                style={{ borderColor: "rgba(250,249,246,0.4)" }}
              >
                <MessageCircle size={18} />
              </a>
              <a
                href={SITE.phoneHref}
                aria-label="Call"
                className="w-11 h-11 border flex items-center justify-center transition-colors hover:bg-[color:var(--dl-bg)] hover:text-[color:var(--dl-ink)]"
                style={{ borderColor: "rgba(250,249,246,0.4)" }}
              >
                <Phone size={18} />
              </a>
              <a
                href={SITE.emailHref}
                aria-label="Email"
                className="w-11 h-11 border flex items-center justify-center transition-colors hover:bg-[color:var(--dl-bg)] hover:text-[color:var(--dl-ink)]"
                style={{ borderColor: "rgba(250,249,246,0.4)" }}
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="overline" style={{ color: "rgba(250,249,246,0.6)" }}>
              Explore
            </p>
            <ul className="mt-5 space-y-3">
              {[
                ["home", "Home"],
                ["cottages", "Cottages"],
                ["shepherds-huts", "Shepherd's Huts"],
                ["things-to-do", "Things To Do"],
                ["faqs", "FAQs"],
                ["contact", "Contact"],
              ].map(([id, label]) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    data-testid={`footer-link-${id}`}
                    className="hover:underline"
                    style={{ color: "rgba(250,249,246,0.85)" }}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="overline" style={{ color: "rgba(250,249,246,0.6)" }}>
              Visit us
            </p>
            <p className="mt-5 font-serif text-2xl" style={{ fontWeight: 400 }}>
              {SITE.address}
            </p>
            <a href={SITE.phoneHref} className="block mt-4" style={{ color: "rgba(250,249,246,0.85)" }}>
              {SITE.phone}
            </a>
            <a href={SITE.emailHref} className="block mt-1" style={{ color: "rgba(250,249,246,0.85)" }}>
              {SITE.email}
            </a>
          </div>
        </div>

        <div
          className="mt-16 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
          style={{ borderTop: "1px solid rgba(250,249,246,0.15)" }}
        >
          <p className="text-xs" style={{ color: "rgba(250,249,246,0.55)" }}>
            © {year} Cheshire Holidays Limited. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: "rgba(250,249,246,0.55)" }}>
            Made with care in Cheshire.
          </p>
        </div>
      </div>
    </footer>
  );
}
